import React from 'react';
import './App.css';
import Home from "./Components/Home";
function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}
export default App;